import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from './store/auth-store';
import { LoginPage } from './pages/LoginPage';
import { AdminLayout } from './components/AdminLayout';
import { UsersPage } from './pages/UsersPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { AIStatsPage } from './pages/AIStatsPage';
import { SubscriptionsPage } from './pages/SubscriptionsPage';
import { PlansPage } from './pages/PlansPage';
import { UsageMonitoringPage } from './pages/UsageMonitoringPage';
import { InteractionHistoryPage } from './pages/InteractionHistoryPage';
import { CreditRatesPage } from './pages/CreditRatesPage';
import { SupportTicketsPage } from './pages/SupportTicketsPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { SkillsPage } from './pages/SkillsPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/" replace />} />

          {isAuthenticated ? (
            <Route element={<AdminLayout />}>
              <Route path="/" element={<Navigate to="/users" replace />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/organizations" element={<OrganizationsPage />} />
              <Route path="/subscriptions" element={<SubscriptionsPage />} />
              <Route path="/plans" element={<PlansPage />} />
              <Route path="/credit-rates" element={<CreditRatesPage />} />
              <Route path="/skills" element={<SkillsPage />} />
              <Route path="/stats" element={<AIStatsPage />} />
              <Route path="/usage-monitor" element={<UsageMonitoringPage />} />
              <Route path="/interactions" element={<InteractionHistoryPage />} />
              <Route path="/audit-log" element={<AuditLogPage />} />
              <Route path="/support-tickets" element={<SupportTicketsPage />} />
            </Route>
          ) : (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
